import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";

/**
 * A button/link component for external links that open in a new tab
 * @param {string} to - URL to navigate to
 * @param {string} className - Additional CSS classes
 * @param {boolean} disabled - Whether the link is disabled
 * @param {React.ReactNode} children - Link content
 */
export default function ExternalLinkButton({
  to,
  className = "",
  disabled = false,
  children,
  buttonOnTheLeft = false,
}) {
  if (disabled || !to) {
    return (
      <span className={`${className} ${disabled ? "disabled" : ""}`}>
        {children}
      </span>
    );
  }

  if (buttonOnTheLeft) {
    return (
      <Link
        to={to}
        className={className}
        target="_blank"
        rel="noopener noreferrer"
      >
        <FontAwesomeIcon className="me-2" icon={faArrowUpRightFromSquare} />
        {children}
      </Link>
    );
  }

  return (
    <Link
      to={to}
      className={className}
      target="_blank"
      rel="noopener noreferrer"
    >
      {children}
      <FontAwesomeIcon className="ms-2" icon={faArrowUpRightFromSquare} />
    </Link>
  );
}
